import React from 'react'

import { Navbar, Footer } from '../../../components';
import { Article13Doc } from '../individual';

export default function Article13() {
  return (
    <div className='emas__article13'>
        <Navbar />
        <Article13Doc />
        <Footer />
    </div>
  )
}
